import { useEffect, useState } from 'react';
import { useContextTranslation } from '@core/i18n';
import { useVideoEl } from '@embed/components/VideoPlayer/Player3/hooks/useVideoEl';
import { AGORA_TEXT_CUES_WRAPPER } from '@player/testIds';
import { CueWrapper, TextCueWrapper, UsernameWrapper } from '../TextCues.styles';
import { formatAgoraWords, isFullMessage, isStaleMessage, MESSAGE_TTL, speakerFactory, } from './helpers';
const AUTOGENERATED_MESSAGE_DURATION = 2000;
/**
 * A component to display text cues for real time subtitles returned from Agora
 */
export const AgoraTextCues = ({ setShowAutogeneratedMessage, showAutogeneratedMessage, top, }) => {
    const wrapper = useVideoEl();
    const [conversation, setConversation] = useState([]);
    const { t } = useContextTranslation();
    useEffect(() => {
        if (showAutogeneratedMessage === null) {
            setShowAutogeneratedMessage(true);
            // [CS-5503]: show auto-generated message for 2 seconds
            setTimeout(() => {
                setShowAutogeneratedMessage(false);
            }, AUTOGENERATED_MESSAGE_DURATION);
        }
    }, [setShowAutogeneratedMessage, showAutogeneratedMessage]);
    useEffect(() => {
        if (!wrapper) {
            return;
        }
        let staleTimeout;
        wrapper.onSubtitles((words, uid) => {
            setConversation((currentConvo) => {
                const newConvo = currentConvo
                    // if there's too many words, we start a new message. Ideally
                    // any message maxes around 2 lines
                    .filter((speaker) => !isFullMessage(speaker))
                    //if it's been some time since this speaker last spoke, remove from convo
                    .filter((speaker) => !isStaleMessage(speaker));
                const speakerIndex = newConvo.findIndex((speaker) => speaker.user.uid === uid);
                const newSpeaker = speakerFactory(words, uid, wrapper.getUserTrackByUID(uid)?.username);
                if (speakerIndex > -1) {
                    newConvo[speakerIndex] = newSpeaker;
                }
                else {
                    newConvo.push(newSpeaker);
                }
                return newConvo;
            });
            if (staleTimeout) {
                clearTimeout(staleTimeout);
            }
            staleTimeout = setTimeout(() => {
                setConversation((currentConvo) => {
                    return currentConvo.filter((speaker) => !isStaleMessage(speaker));
                });
            }, MESSAGE_TTL);
        });
        return () => {
            wrapper.offSubtitles();
            clearTimeout(staleTimeout);
        };
    }, [wrapper]);
    if (showAutogeneratedMessage) {
        return (<CueWrapper data-testid={AGORA_TEXT_CUES_WRAPPER} top={top}>
        <TextCueWrapper>
          {t('player:(Captions are auto-generated)')}
        </TextCueWrapper>
      </CueWrapper>);
    }
    if (!conversation.length) {
        return null;
    }
    return (<CueWrapper data-testid={AGORA_TEXT_CUES_WRAPPER} top={top}>
      {conversation.map((speaker, i) => {
            const username = speaker.user.name;
            const uid = speaker.user.uid;
            return (<div key={`${uid}-${i}`}>
            <TextCueWrapper>
              {wrapper.userVideoTracks().length > 1 && (<UsernameWrapper>{username}</UsernameWrapper>)}
              {formatAgoraWords(speaker.words)}
            </TextCueWrapper>
          </div>);
        })}
    </CueWrapper>);
};
